import { FormattedMessage } from "react-intl";

import { DEFAULT_VALUES } from "@/libraries/web-framework/src/localization/values";
const SupportAppsIntegrations = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="ConfluencePricingPageTeam24.features.supportAppsIntegrations.content.body"
                    defaultMessage="Integrate Confluence with other apps you’re already using. <a>Learn more.</a>"
                    values={{
                        ...DEFAULT_VALUES,
                        a: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="confluence"
                                data-label-english="Learn More"
                                data-track-event="ConfluencePricingPageTeam24.supportAppsIntegrations.learnMore"
                                data-event-container="ConfluencePriceFinderTeam24"
                                href="https://marketplace.atlassian.com/search?product=confluence"
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};
export default SupportAppsIntegrations;
